import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import React, {useEffect} from 'react';

const DateDefault = ({
  label,
  field,
  fullWidth,
  required,
  disabledPast,
  disabled,
  lookup,
  formikProps,
  typeAddOrEdit,
}: DateProps) => {
  const lookupData = lookup.find((x: any) => x.column === 'iD_Course'); /// Cambiando esto
  const value = new Date();
  const idCourse = formikProps.values['iD_Course'];
  const {errors} = formikProps;

  useEffect(() => {
    if (typeAddOrEdit === 'edit') return;
    if (idCourse === '') {
      formikProps.setFieldValue('expiration_Date', new Date().toUTCString());
    }
    if (idCourse !== 0 && idCourse !== '') {
      //Esto se puede cambiar por !!idCourse
      const data = lookupData.values.find(
        (x: any) => formikProps.values['iD_Course'] === x.iD_Course,
      );
      if (data.status === 2) {
        value.setDate(value.getDate() + 30);
        formikProps.setFieldValue('expiration_Date', value.toUTCString());
      } else if (data.status === 1) {
        const date_vig = new Date(data.dateVig);
        formikProps.setFieldValue('expiration_Date', date_vig.toUTCString());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idCourse]);

  if (formikProps.values.expiration_Date == null) {
    formikProps.setFieldValue('expiration_Date', '');
  }

  const handleDateChange = (date: Date | null) => {
    formikProps.setFieldValue('expiration_Date', date);
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        label={label}
        fullWidth={fullWidth}
        required={required}
        inputVariant="outlined"
        variant="inline"
        views={['year', 'month', 'date']}
        format="dd/MM/yyyy"
        disablePast={disabledPast}
        disabled={disabled}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
        value={formikProps.values.expiration_Date}
        onChange={handleDateChange}
        helperText={
          Boolean(!!errors['expiration_Date']) ? 'Fecha invalida' : ''
        }
      />
    </MuiPickersUtilsProvider>
  );
};

interface DateProps {
  label: string;
  field: string;
  fullWidth: boolean;
  required: boolean;
  disabledPast: boolean;
  disabled: boolean;
  lookup: any;
  formikProps: any;
  typeAddOrEdit?: string;
}

export default DateDefault;
